export const COVERAGE_AVAILABLE = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Auto-Transfer'
  },
  {
    value: 'drug_name',
    label: 'Product',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Insurance Name',
  },
  {
    value: 'physician',
    label: 'Provider',
  },
  {
    value: 'medical_coverage_status',
    label: ' Medical Coverage (Buy & Bill)',
  },
  {
    value: 'pharmacy_coverage_status',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  //  {
  //   value: '',
  //   label: 'Copay Status',
  // },
  // {
  //   value: '',
  //   label: 'Provide Treatment Status',
  // },
  {
    value : '',
    label: 'FRM Note'
  }
];
export const COVERAGE_MANUFACTURE_AVAILABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case type',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Patient Activation Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
  
 
];
export const ACTION_REQUIRED = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Auto-Transfer'
  },
  {
    value: 'drug_name',
    label: 'Product',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Insurance Name',
  },
  {
    value: 'physician',
    label: 'Provider',
  },
  {
    value: 'medical_coverage_status',
    label: 'Medical Coverage (Buy & Bill)',
  },
  {
    value: 'pharmacy_coverage_status',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  {
    value: '',
    label: ' Next Step',
  },
]
export const ACTION_MANUFACTURE_REQUIRED = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case type',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Patient Activation Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
  
]
export const SPECIALITY_PHARMACY = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value:'drug_name',
    label:'Product'
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: 'date_transferred',
    label: 'Date Transferred',
  },
  {
    value: 'pharmacy_sp_status',
    label: 'Pharmacy (SP) Status',
  },
 
  {
    value: '',
    label: 'SP substatus',
  },
  {
    value: 'sp_transferred_to',
    label: 'SP Transferred to',
  },
  // {
  //   value: 'date_transferred',
  //   label: 'Date Transferred',
  // },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: 'date_shipped',
    label: 'Date Shipped',
  },
  // {
  //   value: '',
  //   label: 'Carrier',
  // },
  // {
  //   value: '',
  //   label: 'Tracking Number',
  // },
  
]
export const PENDING_TABLE = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Auto-Transfer'
  },
  {
    value:'drug_name',
    label:'Product'
  },
  // 
  {
    value: 'bi_submitted',
    label: 'BI Submitted',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Insurance Name',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: 'medical_coverage_status',
    label: ' Medical Coverage (Buy & Bill)',
  },
  {
    value: 'pharmacy_coverage_status',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  {
    value: '',
    label: ' Next Step',
  },
  
];
export const COPAY_TABLE = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'Case ID',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value:'date_of_service',
    label:'Date of Service'
  },
  {
    value:'insurance_name',
    label:'Insurance Name'
  },
  {
    value:'practice_name',
    label:'Practice Name'
  },
  {
    value:'provider',
    label:'Provider'
  },
  {
    value:'copay_status',
    label:'Copay Status'
  },
  {
    value:'days_until_copay_claim_filed',
    label:'Days Until Copay Claim Can be Filed'
  },
  // {
  //   value:'drug_name',
  //   label:'Product'
  // },
  // // 
  // {
  //   value: 'bi_submitted',
  //   label: 'BI Submitted',
  // },
  // {
  //   value:'drug_name',
  //   label:'Product'
  // },
  // // 
  // {
  //   value: 'bi_submitted',
  //   label: 'BI Submitted',
  // },
  
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  // {
  //   value: 'payer',
  //   label: 'Primary Insurance Type',
  // },
  // {
  //   value: 'provider',
  //   label: 'Provider',
  // },
  // {
  //   value: 'medical_coverage_status',
  //   label: ' Medical Coverage (Buy & Bill)',
  // },
  // {
  //   value: 'pharmacy_coverage_status',
  //   label: 'Pharmacy Coverage (Specialty Pharmacy)',
  // },
  //  {
  //   value: 'copay_status',
  //   label: 'Copay Status',
  // },
  // {
  //   value: 'provider',
  //   label: 'Provider',
  // },
  // {
  //   value: 'medical_coverage_status',
  //   label: ' Medical Coverage (Buy & Bill)',
  // },
  // {
  //   value: 'pharmacy_coverage_status',
  //   label: 'Pharmacy Coverage (Specialty Pharmacy)',
  // },
  //  {
  //   value: 'copay_status',
  //   label: 'Copay Status',
  // },
  // {
  //   value: '',
  //   label: ' Next Step',
  // },
  
];
export const SPECIALITY_MANUFACTURE_PHARMACY = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Provider',
  },
  
  {
    value: '',
    label: 'SP Transferred To',
  },
  {
    value: '',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: '',
    label: 'Date Shipped',
  },
  {
    value: '',
    label: 'Carrier',
  },
  {
    value: '',
    label: 'Tracking Number',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
]
export const PENDING_MANUFACTURE_TABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case Type	',
  },
  {
    value: '',
    label: 'BI Submitted',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
];
